import styled from 'styled-components';
import { useEffect, useRef, useState } from 'react';
import { useWindowScroll } from 'react-use';
import { useNavBarHeight } from 'utils/hooks/useNavBarHeight';
import PageHeader from './PageHeader';
import { PAGE_HEADER_VARIANTS } from './constants';
import { PageHeaderProps } from './types';

const Spacer = styled.div<{ height: number }>`
  height: ${({ height }) => height}px;
  width: 100%;
  background-color: transparent;
  margin-top: ${(props) => `-${props.theme.spacing.utils.pxToRem(20)}`};
`;

type StickyPageHeaderProps = PageHeaderProps & {
  isShrinking?: boolean;
};

export const StickyPageHeader = ({ isShrinking = false, ...props }: StickyPageHeaderProps) => {
  const { y: scrollY } = useWindowScroll();
  const navBarHeight = useNavBarHeight();
  const isPastScrollBreakpoint = scrollY > navBarHeight;
  const ref = useRef<HTMLDivElement>(null);
  const [spacerHeight, setSpacerHeight] = useState(0);

  useEffect(() => {
    const refHeight = ref?.current?.offsetHeight || 0;
    setSpacerHeight(refHeight);
  }, [navBarHeight, ref, setSpacerHeight]);

  return (
    /**
     * Spacer div is necessary because the sticky header shrinks on scroll,
     * which shrinks page content, triggering a scroll event, and an infinite loop.
     * The Spacer reserves space for the sticky header to cover when the window is not scrolled.
     */
    <Spacer height={spacerHeight}>
      <PageHeader
        variant={PAGE_HEADER_VARIANTS.STICKY}
        navBarHeight={navBarHeight}
        isPastScrollBreakpoint={isShrinking ? isPastScrollBreakpoint : false}
        ref={ref}
        {...props}
      />
    </Spacer>
  );
};
